import { RouteType } from "types/RouteType";
import type { RootStore } from "@intrasync/stores";
import FreightMatchingStore from "./FreightMatching.Store";

/**
 * Freight Matching Route
 *
 * Third-party freight matching system per Implementation Plan Phase 1
 * - Match vendor material invoices with freight carrier invoices
 * - Auto-matching algorithm with configurable tolerances
 * - Discrepancy tracking and resolution
 * - Unit conversion (tons/lbs)
 */
const freightMatchingRoute: RouteType = {
  name: "Freight Matching",
  path: "/accounting/freight-matching",
  layout: "/app",
  viewportCard: {
    header: {
      title: "Freight Matching",
      enableRefreshButton: true,
      enableBackButton: true,
      color: "primary",
      component: () => import("./FreightMatching.Header"),
    },
    body: {
      component: () => import("./FreightMatching.Body"),
      grayBackground: true,
    },
  },
  group: "Accounting",
  requiresAuth: true,
  requiresAdmin: false,
  requiresPermission: false,
  enableAutoFind: false,
  showCompanySelector: true,
  beforeEnter: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).freightMatchingStore as FreightMatchingStore;
    if (store) {
      await store.loadData();
    }
    return true;
  },
  onParamsChange: async ({ rootStore }: { rootStore: RootStore }) => {
    const store = (rootStore as any).freightMatchingStore as FreightMatchingStore;
    if (store) {
      await store.loadData();
    }
  },
  dialogs: [
    {
      name: "createMatchingGroup",
      title: "Create Matching Group",
      component: () => import("./dialogs/CreateMatchingGroupDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        // Group creation handled in dialog
      },
      cancelButton: true,
      height: 500,
    },
    {
      name: "addVendorLine",
      title: "Add Vendor Invoice Line",
      component: () => import("./dialogs/AddVendorLineDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any).freightMatchingStore as FreightMatchingStore;
        if (store.newVendorLine) {
          store.addVendorLine(store.newVendorLine as any);
        }
      },
      cancelButton: true,
      height: 450,
    },
    {
      name: "addFreightLine",
      title: "Add Freight Invoice Line",
      component: () => import("./dialogs/AddFreightLineDialog.Body"),
      onSubmit: async ({ rootStore }: { rootStore: RootStore }) => {
        const store = (rootStore as any).freightMatchingStore as FreightMatchingStore;
        if (store.newFreightLine) {
          store.addFreightLine(store.newFreightLine as any);
        }
      },
      cancelButton: true,
      height: 500,
    },
    {
      name: "resolveDiscrepancy",
      title: "Resolve Discrepancy",
      component: () => import("./dialogs/ResolveDiscrepancyDialog.Body"),
      cancelButton: true,
      height: 350,
    },
  ],
};

export default freightMatchingRoute;
